import { FormularioPassword } from '@eg/compartido'

/** Inicio de sesión del equipo: correo y contraseña. Sin registro público: el administrador da de alta al personal. */
export function Acceso() {
  return <FormularioPassword />
}
